// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function StarBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M30.375 12.006a2.5 2.5 0 0 0-2.158-1.715l-7.125-.616-2.787-6.643a2.5 2.5 0 0 0-4.603 0l-2.79 6.643-7.126.616a2.5 2.5 0 0 0-1.427 4.384L7.774 19.4l-1.625 7.03a2.5 2.5 0 0 0 3.726 2.707L16 25.418l6.125 3.72a2.499 2.499 0 0 0 3.725-2.707l-1.625-7.03 5.415-4.725a2.5 2.5 0 0 0 .735-2.669Zm-8.344 5.328a2.5 2.5 0 0 0-.794 2.454l1.424 6.165-5.367-3.26a2.487 2.487 0 0 0-2.588 0l-5.367 3.26 1.423-6.165a2.5 2.5 0 0 0-.793-2.454L5.207 13.18l6.268-.543a2.491 2.491 0 0 0 2.086-1.523L16 5.302l2.439 5.812a2.49 2.49 0 0 0 2.086 1.523l6.267.543-4.76 4.154Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
